// do not expose this model outside of payment form, only used within the payment iframe component
export class PaymentCardResponse {
    public id: string;
    public name: string;
    public type: string;
    public last4: string;
    public addressLine1: string;
    public addressCity: string;
    public addressState: string;
    public addressZip: string;
    public addressCountry: string;
    public expMonth: number;
    public expYear: number;
    public dateCreated: string;
    public cardEntryMode: string;
    public indicator: string;
    public indicatorSource: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/payment-card-response.model.ts